import InitInfo from '../utils/InitInfo';

function PickCategoryByPageId(category, pageId) {
    const { categoryAr = [] } = InitInfo();

    return categoryAr[category]?.find((item) => item.page_id === pageId) || {};
}

export default PickCategoryByPageId;
